/**
 * Created by Alex on 22-Mar-19.
 */
import React from 'react';
import { Button, Modal, Form, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { serverService } from '../../../_services/server.service';
import QuestionsAutocomplete from '../../_other/QuestionsAutocomplete';

import VoxSelect from '../../_other/VoxSelect';
import LocationSelect from '../../_other/LocationSelect';
import i18n from 'i18next';
import { Trans } from 'react-i18next';

import moment from 'moment'

interface MyProps {
  selectedIdVox: number;
  selectedIdLocation: number;
  searchedText: string;
  selectedDay: any;

  onScheduleAdded(): any;
  show: boolean;
  onHide(): any;
}

interface MyState {
  submitted: boolean;
  loading: boolean;
  error: string;
  formFields: any;

  selectedIdVox: number;
  selectedIdLocation: number;
  selectedImage: File | null;
  imagePreviewUrl: string | null;
  showImageDisclaimer: boolean;
}

class ModalAddNewSchedule extends React.Component<MyProps, MyState> {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
      loading: false,
      error: '',
      formFields: {},
      selectedIdVox: 0,
      selectedIdLocation: 0,
      selectedImage: null,
      imagePreviewUrl: null,
      showImageDisclaimer: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.handleQuestionChange = this.handleQuestionChange.bind(this);
    this.onVoxSelected = this.onVoxSelected.bind(this);
    this.onLocationSelected = this.onLocationSelected.bind(this);
    this.handleImageClick = this.handleImageClick.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleRemoveImage = this.handleRemoveImage.bind(this);
    this.closeImageDisclaimer = this.closeImageDisclaimer.bind(this);
    this.handleDisclaimerAccept = this.handleDisclaimerAccept.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {
    // Nettoyer l'URL de preview pour éviter les fuites mémoire
    if (this.state.imagePreviewUrl) {
      URL.revokeObjectURL(this.state.imagePreviewUrl);
    }
  }

  handleChange(e) {
    const { name, value } = e.target;
    const formFields = this.state.formFields;
    formFields[name] = value;
    this.setState({ formFields: formFields });
  }

  handleImageClick() {
    // Vérifier si la date est dans plus de 45 jours
    const selectedDate = moment(this.props.selectedDay);
    const fortyFiveDaysFromNow = moment().add(45, 'days');
    
    if (selectedDate.isAfter(fortyFiveDaysFromNow)) {
      toast.error('Cannot add image for questions scheduled more than 45 days in the future');
      return;
    }
    
    this.setState({ showImageDisclaimer: true });
  }

  closeImageDisclaimer() {
    this.setState({ showImageDisclaimer: false });
  }

  handleDisclaimerAccept() {
    this.setState({ showImageDisclaimer: false });
    // Déclencher l'input file
    const fileInput = document.getElementById('imageInputSchedule') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  handleImageChange(e) {
    const file = e.target.files?.[0];
    if (!file) return;

    // Vérifier le format PNG
    if (file.type !== 'image/png') {
      toast.error('Format PNG uniquement');
      return;
    }

    // Valider dimensions et aspect ratio
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    
    img.onload = () => {
      const width = img.width;
      const height = img.height;
      const ratio = width / height;

      // Vérifier dimensions minimales
      if (width < 2000 || height < 1200) {
        toast.error('Dimensions minimales : 2000 x 1200 px');
        URL.revokeObjectURL(objectUrl);
        return;
      }

      // Vérifier aspect ratio (1.6 à 1.8)
      if (ratio < 1.6 || ratio > 1.8) {
        toast.error('Ratio largeur/hauteur doit être entre 1.6 et 1.8');
        URL.revokeObjectURL(objectUrl);
        return;
      }

      // Tout est OK
      this.setState({
        selectedImage: file,
        imagePreviewUrl: objectUrl
      });
    };

    img.src = objectUrl;
  }

  handleRemoveImage() {
    if (this.state.imagePreviewUrl) {
      URL.revokeObjectURL(this.state.imagePreviewUrl);
    }
    this.setState({
      selectedImage: null,
      imagePreviewUrl: null
    });
  }

  uploadImageIfNeeded(IdQuestion) {
    const { selectedImage } = this.state;
    
    if (!selectedImage) {
      return Promise.resolve();
    }

    const formData = new FormData();
    formData.append('image', selectedImage);

    return serverService.uploadQuestionImage(IdQuestion, formData);
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });

    const { formFields, selectedIdVox, selectedIdLocation, selectedImage } = this.state;
    const Question = formFields.Question;

    // stop here if form is invalid
    if (!Question) {
      toast.error('You need to type a text');
      return;
    }

    // Bloquer si image présente mais texte vide
    if (selectedImage && !Question.trim()) {
      toast.error("You need to type a text");
      return;
    }

    let userStr = localStorage.getItem('user');
    let IdUser = 0;
    if (userStr) {
      const userObj = JSON.parse(userStr);
      IdUser = userObj.IdUser;
    }

    this.setState({ submitted: true, loading: true });

    let question = {
      IdQuestion: 0,
      IdUser: IdUser.toString(),
      QuestionText: Question,
    };
    serverService.insertQuestion(question).then(
      insertQuestionResult => {
        const IdQuestion = insertQuestionResult.data.IdQuestion;

        // Upload image si présente
        this.uploadImageIfNeeded(IdQuestion).then(
          () => {
            // Image uploadée (ou pas d'image), continuer avec les schedules
            let insertPromises = [];
            if (selectedIdVox == 0) {
              let getVoxesPromise;
              if (selectedIdLocation == 0) {
                getVoxesPromise = serverService.getAllActiveVoxes();
              } else {
                getVoxesPromise = serverService.getAllVoxesAtLocation(
                  selectedIdLocation
                );
              }

              getVoxesPromise.then(
                getVoxesResult => {
                  const voxes = getVoxesResult.data;

                  for (let i = 0; i < voxes.length; i++) {
                    const schedule = {
                      IdVox: voxes[i].IdVox.toString(),
                      IdQuestion: IdQuestion.toString(),
                      Date: this.props.selectedDay,
                    };
                    let tempPromise = serverService.insertSchedule(schedule);
                    insertPromises.push(tempPromise);
                  }

                  Promise.all(insertPromises).then(
                    result => {
                      this.setState({ submitted: false, loading: false });

                      this.props.onHide();
                      this.props.onScheduleAdded();
                      toast.success(
                        i18n.t('trans_33_modal_schedule_msg_questions_scheduled')
                      );
                    },
                    error => {
                      toast.warn('Did not insert schedule');
                      this.setState({ loading: false });
                    }
                  );
                },
                error => {
                  toast.warn('Did not get voxes');
                  this.setState({ loading: false });
                }
              );
            } else {
              const schedule = {
                IdVox: selectedIdVox,
                IdQuestion: IdQuestion.toString(),
                Date: this.props.selectedDay,
              };
              serverService.insertSchedule(schedule);
              insertPromises.push();

              Promise.all(insertPromises).then(
                result => {
                  this.setState({ submitted: false, loading: false });

                  this.props.onHide();
                  this.props.onScheduleAdded();
                  toast.success(
                    i18n.t('trans_33_modal_schedule_msg_questions_scheduled')
                  );
                },
                error => {
                  toast.warn('Did not insert schedule');
                  this.setState({ loading: false });
                }
              );
            }
          },
          error => {
            toast.warn('Failed to upload image');
            this.setState({ loading: false });
          }
        );
      },
      error => {
        toast.warn('Did not insert question');
        this.setState({ loading: false });
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps != this.props) {
      // Nettoyer l'ancienne preview si elle existe
      if (this.state.imagePreviewUrl) {
        URL.revokeObjectURL(this.state.imagePreviewUrl);
      }

      this.setState({
        submitted: false,
        loading: false,
        error: '',
        formFields: {},
        selectedIdVox: this.props.selectedIdVox,
        selectedIdLocation: this.props.selectedIdLocation,
        selectedImage: null,
        imagePreviewUrl: null,
        showImageDisclaimer: false,
      });
    }
  }

  render() {
    let { loading } = this.state;

    let titleStr = i18n.t('trans_33_modal_schedule_title');
    let confirmButtonStr = i18n.t('trans_33_Submit');
    let cancelButtonStr = i18n.t('trans_33_Cancel');

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        dialogClassName='modal-90w'
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header
          className='add-vox-modal-header'
          closeButton
          translate='yes'
        >
          <Modal.Title id='example-custom-modal-styling-title'>
            {titleStr}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='add-vox-modal-content'>
          <Form onSubmit={this.handleSubmit}>
              <div className="p-3" >
              <b>{moment(this.props.selectedDay).format('DD/MM/YY')}</b>
              </div>
            {/* <br /> */}
            <Form.Group controlId='formBasicName'>
              <Form.Label>
                *<Trans>trans_33_Question</Trans>
              </Form.Label>
              <QuestionsAutocomplete
                key="questionsAutoComplete"
                selectedQuestion={this.state.formFields.Question}
                handleQuestionChange={this.handleQuestionChange}
              />
            </Form.Group>

            <br/>

            {/* Section Image */}
            <Form.Group>
              <Form.Label>Image (optional)</Form.Label>
              <div>
                <input
                  type="file"
                  accept="image/png"
                  onChange={this.handleImageChange}
                  style={{ display: 'none' }}
                  id="imageInputSchedule"
                />
                <Button 
                  variant="secondary" 
                  size="sm"
                  onClick={this.handleImageClick}
                >
                  📷 Add a picture
                </Button>
                
                {this.state.imagePreviewUrl && (
                  <div style={{ marginTop: '10px' }}>
                    <img 
                      src={this.state.imagePreviewUrl} 
                      alt="Preview" 
                      style={{ maxWidth: '300px', maxHeight: '200px', border: '1px solid #ddd', borderRadius: '4px' }}
                    />
                    <br/>
                    <Button 
                      variant="danger" 
                      size="sm" 
                      onClick={this.handleRemoveImage}
                      style={{ marginTop: '5px' }}
                    >
                      ❌ Remove picture
                    </Button>
                  </div>
                )}
              </div>
            </Form.Group>

            <div className="p-3" >
              <Trans>trans_33_modal_schedule_display_at</Trans> &nbsp;
              <br/>
              <span style={{ display: 'inline-block' }}>
                <LocationSelect
                  selectedIdLocation={this.state.selectedIdLocation}
                  onLocationSelected={this.onLocationSelected}
                />
              </span>
              &nbsp;on&nbsp;
              <span style={{ display: 'inline-block' }}>
                <VoxSelect
                  selectedIdLocation={this.state.selectedIdLocation}
                  selectedIdVox={this.state.selectedIdVox}
                  onVoxSelected={this.onVoxSelected}
                />
              </span>
            </div>

            <br />

            <div style={{ textAlign: 'right' }}>
              <Button variant='secondary' onClick={this.props.onHide}>
                {cancelButtonStr}
              </Button>
              &nbsp;
              <Button variant='primary' type='submit' disabled={loading}>
                {confirmButtonStr}
              </Button>
              {loading && (
                <img
                  alt='loading'
                  src='data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=='
                />
              )}
            </div>
          </Form>
        </Modal.Body>

        <br />

        {/* Modale Disclaimer Image */}
        <Modal
          show={this.state.showImageDisclaimer}
          onHide={this.closeImageDisclaimer}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>⚠️ Important - Picture for question</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p><strong>Before adding a picture, please note:</strong></p>
            <ul>
              <li>The <strong>text on the picture</strong> must match the <strong>question text</strong></li>
              <li>The <strong>question text field cannot be empty</strong></li>
              <li>Minimum dimensions: <strong>2000 x 1200 px</strong></li>
              <li>Width/height ratio: <strong>between 1.6 and 1.8</strong></li>
              <li>Format: <strong>PNG only</strong></li>
            </ul>
            <p>💡 <strong>Tip:</strong> Create your image in PowerPoint (exports as 4000x2250, perfect!)</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeImageDisclaimer}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.handleDisclaimerAccept}>
              Got it, choose picture
            </Button>
          </Modal.Footer>
        </Modal>
      </Modal>
    );
  }


 

  handleQuestionChange(questionString) {
    let formFields = this.state.formFields;
    formFields.Question = questionString;
    this.setState({ formFields: formFields });
  }
  

  onVoxSelected(IdVox) {
    this.setState({ selectedIdVox: IdVox });
  }

  onLocationSelected(IdLocation) {
    this.setState({ selectedIdLocation: IdLocation });
  }
}

export default ModalAddNewSchedule;